<template>
	<div class="wrapper">
		<headerTag />
			<div class="userCon baseMess clear" style="margin-top: 4.73rem;">
				<p>
					<span>
						<img src="../../assets/images/user/mess_icon1.png" alt="" />
						账号
					</span>
					<span style="background: 0;">
						{{username}}
					</span>
				</p>
				
				<p>
					<router-link :to="{ name:'phoneChange' }">
						<span>
							<img src="../../assets/images/user/mess_icon2.png" alt="" />
							手机号
						</span>
						<span v-else-if="">
							{{phone}}
						</span>
					</router-link>
				</p>
				
				<p>
					<span>
						<img src="../../assets/images/user/mess_icon3.png" alt="" />
						性别
					</span>
					<span @click="sexPicker = true">
						{{sexValue}}
					</span>
				</p>
				<p>
					<span>
						<img src="../../assets/images/user/mess_icon4.png" alt="" />
						出生日期
					</span>
					<span @click="birthdayPicker = true">
						{{birthday}}
					</span>
				</p>
				
				<p>
					<router-link :to="{ name:'qqChange' }">
						<span>
							<img src="../../assets/images/user/mess_icon5.png" alt="" />
							QQ
						</span>
						<span>
							{{qq}}
						</span>
					</router-link>
				</p>
				
				<p style="border-bottom: 0;">
					<router-link :to="{ name:'passwordChange' }">
						<span>
							<img src="../../assets/images/user/mess_icon6.png" alt="" />
							密码
						</span>
						<span>
							设置密码
						</span>
					</router-link>
				</p>
				
			</div>
		<footerTag />
		
		<!--性别选择-->
		
		<van-popup v-model="sexPicker" position="bottom">
			  <van-picker
				show-toolbar
				:columns="columns"
				@cancel="sexPicker = false"
				@confirm="sexConfirm"
			  />
		</van-popup>
		
		<!--生日-->
		<van-popup v-model="birthdayPicker" position="bottom">
			<van-datetime-picker
			  v-model="currentDate"
			  type="date"
			  :min-date="minDate"
			  @cancel="birthdayPicker = false"
			  @confirm="birthdayConfirm"
			  @change="endTimeChange"
			/>
		</van-popup>
		
	</div>

</template>

<script>
   
    import "../../assets/css/user.scss"
    import headerTag from '@/components/headerTag/headerTag.vue'
    import footerTag from '@/components/footerTag/footerTag.vue'
	import { Popup,Picker,DatetimePicker  } from 'vant'

	export default {
		name: 'baseMessage',
		props: {
        
		},
		data(){
			return {
				phone:'',
				username:'',
				sex:'1',
				birthday:'',
				birthdayPicker:false,
				currentDate: new Date(),
				minDate: new Date(1900, 1, 1),
				qq:'',
				sexPicker:false,
				sexValue:'男',
				columns: ['男', '女'],
				birthdayArr:'',
			}
		},
		methods:{
			 sexConfirm(sexValue) {
			      this.sexValue = sexValue;
				  if(this.sexValue=='男'){
				  	 this.sex=1;
				  }else{
					 this.sex=2;
				  }
			      this.sexPicker = false;
				  this.editUserInfo();
			    },
				birthdayConfirm(){
					this.birthday=this.birthday;
					this.birthdayPicker = false;
					this.editUserInfo()
				},
				endTimeChange(e) {
				    let endTimeArr = e.getValues();
				    this.birthday = endTimeArr[0].toString()+'-'; //年
					this.birthday =this.birthday+endTimeArr[1].toString()+'-';//月
					this.birthday =this.birthday+endTimeArr[2].toString();//日
					
				},
				editUserInfo(){
					this.axios({
						method: 'POST',
						url:'/user/saveUserInfo',
						params:{
							sex:this.sex,
							birthday:this.birthday
						},
					}).then((res)=>{
						if(res.data.code==1000){
							 //成功
							 let resultData = res.data.obj;
							 this.sex = resultData.sex;
							 if(this.sex==1){
								 this.sexValue='男';
							 }else{
								 this.sexValue='女';
							 }
							 this.birthday = resultData.birthday;
						}else if(res.data.code == 1110){
				  			//未登录
				  			let currPath=window.location.href;
				  			window.location.href='/login?targetUrl='+currPath;
				  		}else{
							this.$message.error({message: '网络异常，请稍后重试'});
						}
					}).catch((err)=>{
						this.$message.error({message: '网络异常，请稍后重试'});
					})
				},
			loadUserInfo() {
				this.axios({
				    method: 'POST',
				    url:'/user/userInfo',
				}).then((res)=>{
						if(res.data.code==1000){
							 let resultData = res.data.data.user;
							 this.phone = resultData.phone;
							 this.username = resultData.username;
							 this.sex = resultData.sex;
							 if(this.sex==1){
								 this.sexValue='男';
							 }else{
								 this.sexValue='女';
							 }
							 
							 if(resultData.birthday==''){
								 let date=new Date();
								 let mouthNum = date .getMonth()+1;
								 this.birthday= date.getFullYear()+'-'+mouthNum+'-'+date .getDate();
							 }else{
								 this.birthday = resultData.birthday;
							 }
							 
							 this.qq = resultData.qq;
						}else if(res.data.code == 1110){
				  			//未登录
				  			let currPath=window.location.href;
				  			window.location.href='/login?targetUrl='+currPath;
				  		}else{
				  			this.$message.error({message: res.data.message});
				  		}
				}).catch((err)=>{
				    this.$message.error({message: '网络异常，请稍后重试'});
				})
			}
		},
		components: {
			headerTag,
			footerTag,
			[Popup.name]:Popup,
			[Picker.name]:Picker,
			[DatetimePicker.name]:DatetimePicker,
		},
		created(){
			this.loadUserInfo();
			
		}
	}

</script>